export default __webpack_public_path__ + "static/media/bigfix_logo_white.c3ba8499.png";